import { apiClient } from "./client";

// ── Types ────────────────────────────────────────────────────────

export interface QAStatus {
  status: "pass" | "warn" | "fail" | "running" | "none";
  failures: number;
  warnings: number;
  run_id: string | null;
  finished_at: string | null;
}

export interface QARun {
  id: string;
  started_at: string;
  finished_at: string | null;
  environment: string;
  commit_hash: string | null;
  status: string;
  total_checks: number;
  passed: number;
  warnings: number;
  failures: number;
}

export interface QACheck {
  id: string;
  hotel_id: string;
  hotel_name: string | null;
  check_name: string;
  category: string;
  status: string;
  message: string | null;
  details: Record<string, unknown> | null;
  duration_ms: number | null;
}

export interface QARunDetail extends QARun {
  checks: QACheck[];
}

// ── API calls ────────────────────────────────────────────────────

export async function getQAStatus(): Promise<QAStatus> {
  const res = await apiClient.get<QAStatus>("/admin/qa-status");
  return res.data;
}

export async function listQARuns(limit = 20): Promise<QARun[]> {
  const res = await apiClient.get<QARun[]>("/admin/qa-runs", {
    params: { limit },
  });
  return res.data;
}

export async function getQARunDetail(runId: string): Promise<QARunDetail> {
  const res = await apiClient.get<QARunDetail>(`/admin/qa-runs/${runId}`);
  return res.data;
}
